import React, { Component } from 'react';
import {Button, PickerView,Flex} from "antd-mobile";
const Style = {
  display: 'flex',
  flex: 1,
  justifyContent: 'space-around'
};
let dataSource = [];
class MateGroup extends Component {
  constructor (props) {
    super(props);
    this.state = {
      birthWeek: ['']
    }
  }
  UNSAFE_componentWillMount() {
    const {data, value} = this.props;
    dataSource = data.map(o => {
      return ({
        label: (
          <div style={{ ...Style}}>
            <span>{o.mateGroup}</span>
            <span>{o.weekStartDate}</span>
            <span>{o.weekEndDate}</span>
          </div>
        ),
        value: o.mateGroup
      })
    });
    this.setState({
      birthWeek: [value]
    })
  }
  ok = () => {
    const {data} = this.props;
    let currentData = data.filter(o => o.mateGroup === this.state.birthWeek[0]);
    if (currentData.length > 0) {
      currentData = currentData[0]
    } else {
      currentData = {}
    }
    this.props.onConfirm(this.state.birthWeek[0], currentData)
  };
  cancel = () => {
    const {value} = this.props;
    this.setState({
      birthWeek: [value]
    });
    this.props.onCancel()
  };
  onChange = (value) => {
    this.setState({
      birthWeek:value
    });
  };
  render() {
    const {birthWeek} = this.state;
    return (
      <div style={{background: '#fff'}}>
        <PickerView
          data={dataSource}
          value={birthWeek}
          cols={1}
          onChange={this.onChange}
        />
        <div style={{padding: '15px 10px',backgroundColor: '#fff'}}>
          <Flex>
            <Flex.Item>
              <Button onClick={this.cancel}>取消</Button>
            </Flex.Item>
            <Flex.Item>
              <Button onClick={this.ok}
                      type="primary"
              >确定</Button>
            </Flex.Item>
          </Flex>
        </div>
      </div>
    )
  }
}
export default MateGroup
